"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _help_1_ = _interopRequireDefault(require("../images/help_1_5.gif"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-unescaped-entities */
var shopping = {
  id: "shopping",
  title: {
    en: "Lesson 5 (Shopping)",
    de: "Lektion 5 (Einkaufen)"
  },
  content: {
    en: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("img", {
      src: _help_1_.default,
      alt: "",
      style: {
        width: "390px",
        height: "274px",
        display: "block",
        margin: "16px auto"
      }
    }), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#FCA610"
      }
    }, "Using the market"), /*#__PURE__*/_react.default.createElement("ol", null, /*#__PURE__*/_react.default.createElement("li", null, "When you first start Ferentus you will begin in the middle of Rog's royal palace."), /*#__PURE__*/_react.default.createElement("li", null, "If you want to find a market, use short cut key M in the mini map."), /*#__PURE__*/_react.default.createElement("li", null, "In most of the towns you can meet merchant NPC, and you can obtain various item(s) from them."), /*#__PURE__*/_react.default.createElement("li", null, "When you find merchant NPC and click on them, business deals will start and the confirm window will appear. When you press purchase button NPC merchants will show their items to you."), /*#__PURE__*/_react.default.createElement("li", null, "Money you earned from your hunt, obtained weapons, armor, and other items to travel more safely in the Ferentus world can be bought and sold."), /*#__PURE__*/_react.default.createElement("li", null, "Merchants are usually divided into weapon, armor, magic, item, and material merchants. Usually each town has them, and each city will have their own special items.")))
  }
};
var _default = shopping;
exports.default = _default;